import React, {Component} from 'react'
import Axios from 'axios'

class PlayerVimeo {
    constructor(id, container) {

        this.id = this._parseID(id);
        this.container = container;
    }

    get imageURL() {
        return new Promise((resolve) => {
            Axios.get('https://vimeo.com/api/v2/video/' + this.id + '.json').then((rs) => {
                if (rs.data && typeof rs.data[0].thumbnail_large !== "undefined")
                    resolve(rs.data[0].thumbnail_large)
            })
        })
    }

    play() {
        let VimeoPlayer = require('@vimeo/player');
        this.player = new VimeoPlayer(this.container, {
            autoplay: true,
            id: this.id
        })
        this.player.on('play', this._onPlay.bind(this));

    }

    stop() {
        if (this.player)
            this.player.pause();
    }

    set onPlayCallback(fn) {
        if (typeof fn === "function")
            this._onPlay = fn;
    }

    _onPlay() {

    }

    //
    // UTILS
    //
    _parseID(id) {
        if (id.indexOf('/') === -1)
            return id;

        let exp = new RegExp('vimeo.com/([^"&?/ ]{6,11})', 'i')
        let match = id.match(exp);
        if (match) {
            return match[1];
        }
        return id;
    }
}

export default (PlayerVimeo)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/PlayerVimeo.js